var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "uiv-modal",
    {
      attrs: { "dismiss-btn": false, "ok-text": "Got it!" },
      on: { hide: _vm.propagateHideEvent },
      model: {
        value: _vm.error,
        callback: function($$v) {
          _vm.error = $$v
        },
        expression: "error"
      }
    },
    [
      _c("div", { staticClass: "error-header" }, [
        _c("div", { staticClass: "error-header-text", staticStyle: {} }, [
          _c("h4", [_c("b", [_vm._v("Error when signing up")])])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "body-text" }, [
        _c("div", { staticClass: "body-text-top" }, [
          _vm._v(
            "\n            Have you signed up previously? Then log in by opening DataMapper on your\n            computer (see description below). If you have not\n            already signed up, please contact support\n        "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal-advice-box" }, [
          _c("p", [
            _c("i", { staticClass: "icon-windows" }),
            _vm._v(" "),
            _c("b", [_vm._v("\n                    Windows\n                ")])
          ]),
          _vm._v(
            "\n            Either go to your start menu and find DataMapper\n            under A or click on the windows key on your keyboard\n            and type 'DataMapper'\n        "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal-advice-box" }, [
          _c("p", [
            _c("i", { staticClass: "icon-apple" }),
            _vm._v(" "),
            _c("b", [_vm._v("\n                    Mac\n                ")])
          ]),
          _vm._v(
            "\n            Either go to your start menu and find DataMapper under A\n            or click on the windows key on your keyboard and type 'DataMapper'\n        "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "body-text-bottom" },
          [
            _vm._v(
              "\n            If DataMapper GDPR is not yet installed on your computer download it\n            "
            ),
            _c("router-link", { attrs: { to: "/download-direct" } }, [
              _vm._v("here")
            ])
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bb9ec682", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb9ec682","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./apps/account/SignupError.vue
// module id = 533
// module chunks = 0